import styled from 'styled-components';

export const StyledShowHamburgerMenuButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5625em 0.375em;
  display: inline-flex;

  ${props =>
    props.isMainMenuSidebarOpened &&
    `background: #e2eaee;
    border-radius: 3px;

    & rect {
      fill: #177dd6;
    }`}
`;
